import React, { useState } from 'react';
import classNames from 'classnames';
import styles from './assets/program-book.module.scss';
import AdminLayout from 'src/components/layout/RoleLayout';
import { RouteComponentProps } from 'react-router';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import Form from '../../components/ProgramBookForm';
import Loader from '../../../../../../components/Loader';
import { useSelector } from 'react-redux';
import { StoreState } from '../../../../../../store/reducers';
import { toast } from 'react-toastify';

export interface StateProps {}

export interface DispatchProps {}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}
export interface Props extends StateProps, DispatchProps, OwnProps {}

const ProgramBookCreateScreen: React.FunctionComponent<Props> = (props: Props) => {
    const [files, setFiles] = useState([]);
    const {
        match: {
            params: { id },
        },
    } = props;
    //102
    const programBook = useSelector((state: StoreState) => state.programBooks);
    const { inProgress, miniLoaderFor } = programBook;
    const handleSub = (handleSubmit: (e: any) => void, e: any) => {
        //if (files.length) {
            handleSubmit(e);
       // } else {
         //   toast.error('Please upload a document');
         //   return false;
       // }
    };
    return (
        <AdminLayout>
            <div className={`${classNames(styles.pageHeading)} ${'pageHeading'}`}>
                <h2 className={`${classNames(styles.pageHeadingTitle)} ${'pageHeadingTitle'}`}>PROGRAM BOOK</h2>
            </div>
            <div className={classNames(styles.wrapForm)}>
                {inProgress ? <Loader/> : null}
                <Form
                    files={files}
                    setFiles={setFiles}
                    handleSub={handleSub}
                    removeFile={(id: any) => {
                        setFiles(files.filter((it: any) => id !== it?.id));
                    }}
                    miniLoaderFor={miniLoaderFor}
                    initialValues={{
                        studentId: id,
                        values: [
                            {
                                values: [],
                                title: 'Skill Acquisition',
                            },
                            {
                                values: [],
                                title: 'Behavior Reduction',
                            },
                        ],
                    }}
                />
            </div>
        </AdminLayout>
    );
};

export default ProgramBookCreateScreen;
